import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import ChangePasswordForm, { PasswordFields } from './ChangePasswordForm';
import useChangePortalPassword from '@/hooks/useApi/useChangePortalPassword';

type ChangePasswordProps = {
  handleContinue: (values: PasswordFields) => void;
  loginRequest: vp.ClientLogin;
};

type FC = FunctionComponent<ChangePasswordProps>;

const ChangePassword: FC = (props: ChangePasswordProps) => {
  const { handleContinue, loginRequest } = props;

  const { response, changePassword } = useChangePortalPassword();
  const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
  const [passwordError, setPasswordErorr] = useState(false);
  const [passwordFeild, setPasswordFeild] = useState<PasswordFields>({ Password: '' });

  useEffect(() => {
    if (response?.Success) {
      handleContinue(passwordFeild);
    } else if (response) {
      setPasswordErorr(true);
      setPasswordErrorMsg(response.ErrorMessage);
    }
  }, [response]);
  const handlers = {
    changePassword: (values: PasswordFields) => {
      setPasswordFeild(values);
      changePassword({
        Username: loginRequest.Username || '',
        OldPassword: loginRequest.Password || '',
        NewPassword: values.Password,
      });
    },
  };
  return (
    <>
      <ChangePasswordForm
        handleFormSubmit={handlers.changePassword}
        hasError={passwordError}
        errorMsg={passwordErrorMsg}
        initialValues={{ Password: '' }}
      />
    </>
  );
};
export default ChangePassword;
